import styled from "@emotion/styled";
import React, { Fragment } from "react";
import { ReactComponent as UpIcon } from "Icons/UpIcon.svg";
const ArrowUpIcon = (props) => {
  const { bgColor } = props;
  return (
    <Fragment>
      <ArrowUp bgColor={bgColor} />
      {/* <UpIcon fill={bgColor} width={"20px"}/> */}
    </Fragment>
  );
};

export default ArrowUpIcon;

const ArrowUp = styled.div`
  padding: 5px 2.5px;
  background-color: ${({ bgColor }) => (!!bgColor ? bgColor : "#6fd87c")};
  border-radius: 0px 0px 1px 1px;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    border-top: 5px solid #6fd87c;
    border-right: 5px solid #6fd87c;
    border-left: 5px solid transparent;
    border-bottom: 5px solid transparent;
    top: 50%;
    left: 50%;
    transform: translate(-55%, -60%) rotate(-45deg);
  }
`;
